import { createI18n } from "vue-i18n";
import { language$ } from "@/entities/tech";
import en from "./en.json";
import ru from "./ru.json";

export const i18n = createI18n({
  legacy: false,
  locale: language$.value,
  messages: {
    ru,
    en,
  },
});
language$.subscribe((value) => {
  i18n.global.locale.value = value;
  document.querySelector("html")?.setAttribute("lang", value);
});
